import React from 'react';
import Img from '../Img';

import styles from './infoButton.module.scss';

class InfoButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isMenuShowed: false,
            displayMenuBelowAnchor: true
        };
        this.handleAchorClick = this.handleAchorClick.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.closePopUp = this.closePopUp.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('touchend', this.handleClickOutside, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('touchend', this.handleClickOutside, false);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleAchorClick(ev) {
        ev.stopPropagation();
        ev.preventDefault();

        // width reduced for Iphone 5 and small resolution devices
        let width = 300;
        if (window.innerWidth > 500) {
            width = 400;
        }

        // Values from left border
        let right = false;
        let transformValue = "translateX(-50%)";
        let distanceFromBorder = ev.nativeEvent.clientX;

        if (ev.nativeEvent.clientX > window.innerWidth / 2) {
            // Values from right border
            right = true;
            distanceFromBorder = window.innerWidth - ev.nativeEvent.clientX;
            transformValue = "translateX(50%)";
        }

        if (distanceFromBorder < width / 2) {
            if (right) {
                transformValue = `translateX(${distanceFromBorder}px)`;
            } else {
                transformValue = `translateX(${-distanceFromBorder}px)`;
            }
        }

        if (this.props.translateXValue) {
            transformValue = `translateX(${this.props.translateXValue})`
        }

        let showBelow = true;
        if (ev.nativeEvent.clientY > (2 * window.innerHeight / 3)) {
            showBelow = false;
        }
        this.setState({
            isMenuShowed: true,
            displayMenuBelowAnchor: showBelow,
            hoverWidth: `${width}px`,
            rightAlign: right,
            transformValue: transformValue
        });
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isMenuShowed) {
            this.closePopUp()
        }
    }

    closePopUp() {
        this.setState({
            isMenuShowed: false
        });
    }


    render() {

        const PopUp = () => {
            return (
                <div
                    className={`${styles.popOverMenu}`}
                >
                    <div className={styles.gradientBar}/>
                    <div className={`${styles.popupContent}`}>
                        <div className={`space-top`}>
                            <label>{this.props.hoverText}</label>
                        </div>
                    </div>
                </div>
            )
        };

        return (
            <div className={`${styles.popOverMenuRoot} ${this.props.children ? '' : styles.ellipsis}`}>
                <div
                    className={`${styles.popOverMenuAnchor} ${this.props.anchorClass ? this.props.anchorClass : ''}`}
                    onClick={this.handleAchorClick}
                >
                    {this.props.children ? this.props.children : (<Img alt="tooltip" src="/img/info-icon.svg"/>)}
                </div>
                {this.state.isMenuShowed && (
                    <div className={`${styles.anchorClickDisabler}`}>
                    </div>
                )}
                <div
                    className={`${styles.menuContainer}  ${this.state.displayMenuBelowAnchor ? styles.belowAnchor : styles.aboveAnchor}`}
                    style={this.state.rightAlign ? {
                        width: this.state.hoverWidth,
                        right: "15px",
                        transform: this.state.transformValue
                    } : {
                        width: this.state.hoverWidth,
                        left: "30px",
                        transform: this.state.transformValue
                        }
                    }
                    ref={this.setWrapperRef}
                >
                    {this.state.isMenuShowed && (
                        <PopUp/>
                    )}
                </div>
            </div>

        );
    }
}

export default InfoButton;